import { render, staticRenderFns } from "./dialogItemEdit.vue?vue&type=template&id=3cb57796"
import script from "./dialogItemEdit.vue?vue&type=script&lang=js"
export * from "./dialogItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports